var React = require('react');

function Minus (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"icon_-","data-name":"icon / -","transform":"translate(0)"},[React.createElement("path",{"id":"Path_2282","data-name":"Path 2282","d":"M0,0H24V24H0Z","transform":"translate(0)","fill":"none","key":0}),React.createElement("path",{"id":"Line_370","data-name":"Line 370","d":"M18,.75H0V-.75H18Z","transform":"translate(3 12)","fill":"#0f0f0f","key":1})]));
}

Minus.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Minus;

Minus.default = Minus;
